export default (context) => {
  const M = "admAssignment."
  return {
    config: {
      pageSize: 40,
      list: false,
      remapRow: (form) => {
        return form
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    form: {
      fields: [
        {
          col: 6,
          name: "type",
          value: "",
          type: "select",
          label: `${M}questionType`,
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              { value: "text", label: "Texto" },
              { value: "number", label: "Número" },
              { value: "textarea", label: "Texto largo" },
              { value: "check", label: "Check" },
              { value: "option", label: "Lista de opciones" },
              { value: "optionMany", label: "Lista de opciones (múltiple)" }
            ]
          }
        },
        {
          col: 4,
          name: "langSwitch",
          value: false,
          type: "switch",
          label: (L, state) => { return `${L["main.language"]}: ${state.langSwitch ? L["main.english"] : L["main.spanish"]}` },
        },
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: `${M}questionStatement`,
          placeholder: `${M}example1`,
          rules: "required",
          opts: {
            style: 'float-label',
          },
          renderIf: (ctx) => !ctx.state.langSwitch
        },
        {
          col: 12,
          name: "desc",
          value: "",
          type: "editor",
          label: "main.desc",
          renderIf: (ctx) => !ctx.state.langSwitch
        },
        {
          col: 12,
          name: "placeholder",
          value: "",
          type: "text",
          label: `${M}helpTextToShow`,
          placeholder: `${M}example2`,
          opts: {
            style: 'float-label',
          },
          renderIf: (ctx) => !ctx.state.langSwitch
        },
        {
          col: 12,
          name: "options",
          value: "",
          type: "text",
          label: `${M}inCaseOfBeingOptionsList`,
          placeholder: `${M}answerOptions`,
          opts: {
            style: 'float-label',
          },
          renderIf: (ctx) => !ctx.state.langSwitch
        },
        {
          col: 12,
          name: "nameEN",
          value: "",
          type: "text",
          label: `${M}questionStatement`,
          rules: "required",
          opts: {
            style: 'float-label',
          },
          renderIf: (ctx) => ctx.state.langSwitch
        },
        {
          col: 12,
          name: "descEN",
          value: "",
          type: "editor",
          label: "main.desc",
          renderIf: (ctx) => ctx.state.langSwitch
        },
        {
          col: 12,
          name: "placeholderEN",
          value: "",
          type: "text",
          label: `${M}helpTextToShow`,
          opts: {
            style: 'float-label',
          },
          renderIf: (ctx) => ctx.state.langSwitch
        },
        {
          col: 12,
          name: "optionsEN",
          value: "",
          type: "text",
          label: `${M}inCaseOfBeingOptionsList`,
          opts: {
            style: 'float-label',
          },
          renderIf: (ctx) => ctx.state.langSwitch
        },
        {
          col: 12,
          name: "correctAnswer",
          value: "",
          type: "text",
          label: `${M}correctAnswer`,
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "points",
          value: "",
          type: "number",
          label: `${M}pointsIfCorrect`,
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "pointsNeg",
          value: "",
          type: "number",
          label: `${M}pointsIfIncorrect`,
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 4,
          name: "inactive",
          value: false,
          type: "switch",
          label: "main.inactive",
        },
      ]
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.type",
        accessor: "type",
      },
      {
        Header: `${M}pointsIfCorrect`,
        accessor: "points"
      },
      {
        Header: `${M}pointsIfIncorrect`,
        accessor: "pointsNeg"
      }
    ]
  }
}